import { shallowMount } from "@vue/test-utils";
import SectionLabel from "@/components/core/SectionLabel";

describe("SectionLabel component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(SectionLabel);
  });

  it("Renders del component SectionLabel", () => {
    expect(wrapper).toBeDefined();
  });
});
